import { render, staticRenderFns } from "./Us.vue?vue&type=template&id=85755d48&scoped=true"
import script from "./Us.vue?vue&type=script&lang=js"
export * from "./Us.vue?vue&type=script&lang=js"
import style0 from "./Us.vue?vue&type=style&index=0&id=85755d48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85755d48",
  null
  
)

export default component.exports